export const dateLocaleFor = lng => (lng === 'pt' ? 'pt-BR' : 'en-US')
